import { PartnerBrandingConfig } from '@/schemas/clientInitSchema';
import { createContext } from 'react';
import { generateTheme } from '../../config/themes/base-theme';

interface BrandingContextInterface {
  partnerBrandingConfig: PartnerBrandingConfig | undefined;
  setBranding: (config: PartnerBrandingConfig) => void;
  partnerTheme: ReturnType<typeof generateTheme> | undefined;
  isPartnerThemeLoading: boolean;
}

const defaultContext = {
  isPartnerThemeLoading: true,
  partnerBrandingConfig: undefined,
  setBranding: () => {},
  partnerTheme: undefined,
};

export const BrandingContext = createContext<BrandingContextInterface>(defaultContext);
